/**
 * @generated SignedSource<<63b8d7e9436af36fcb82590d1e8e9bf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_SidebarLayout_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
  readonly " $fragmentType": "main_issueNavigator_SidebarLayout_project";
};
export type main_issueNavigator_SidebarLayout_project$key = {
  readonly " $data"?: main_issueNavigator_SidebarLayout_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_SidebarLayout_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_SidebarLayout_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "81031ed0c3f17c27b9c7422bd922c6e2";

export default node;
